import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { WithdrawalLoadingDesktop } from './Desktop';
import { WithdrawalLoadingMobile } from './Mobile';
import { WithdrawalLoadingTablet } from './Tablet';

export const WithdrawalLoading: React.FC = () => {
  return useBreakpointValue({
    base: <WithdrawalLoadingMobile />,
    sm: <WithdrawalLoadingTablet />,
    lg: <WithdrawalLoadingDesktop />,
  });
};
